import APIService from "@/services/APIService";
import store from "@/store";
import { refreshMesskursPermissions } from "@/services/messkursPermissions";

function getQueryParam(name) {
    const url = new URL(window.location.href);
    return url.searchParams.get(name);
}

function removeQueryParam(name) {
    const url = new URL(window.location.href);
    url.searchParams.delete(name);
    window.history.replaceState({}, "", url.toString());
}

export async function bootstrapLoginFromCltoken() {
    const cltoken = getQueryParam("cltoken");
    if (!cltoken) return { bootstrapped: false };

    try {
        const loginData = await APIService.otpLogin(cltoken);
        removeQueryParam("cltoken");

        if (!loginData || !loginData.user) {
            return { bootstrapped: false };
        }

        loginData.user.isSSO = true;
        store.commit("updateUser", loginData);
        store.commit("setShowHeader", true);
        await refreshMesskursPermissions();

        return { bootstrapped: true, user: loginData.user };
    } catch (e) {
        removeQueryParam("cltoken");
        return { bootstrapped: false, error: e };
    }
}
